import { render } from "./GaugeComp.vue?vue&type=template&id=4cb0f2b6&scoped=true"
import script from "./GaugeComp.vue?vue&type=script&lang=js"
export * from "./GaugeComp.vue?vue&type=script&lang=js"

import "./GaugeComp.vue?vue&type=style&index=0&id=4cb0f2b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.108.4_postcss@8.5.16_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb0f2b6"]])

export default __exports__